import React from 'react'
import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import { showToastNotification } from '@/utility/helper'
import { ThrowError } from '@/api/callApi'
import OffboardingService from '@/services/Offboarding/OffboardingService'
import type { IOffboardingProcessStep } from '@/interface/offboarding.interface'

interface AssetClearanceStepProps {
    isLoading: boolean;
    setIsLoading: (val: boolean) => void;
    userId: string;
    onNext: () => void;
    clearanceSteps: IOffboardingProcessStep[];
    setClearanceSteps: React.Dispatch<React.SetStateAction<IOffboardingProcessStep[]>>;
    isCompleted: boolean;
}

const AssetClearanceStep: React.FC<AssetClearanceStepProps> = ({
    isLoading,
    setIsLoading,
    userId,
    onNext,
    clearanceSteps,
    setClearanceSteps,
    isCompleted
}) => {

    const assetStep = clearanceSteps.find(step => step.key === "asset-return")
    const isAssetCompleted = assetStep?.status === "COMPLETED"
    console?.log("isCompleted", isCompleted)

    const toggleStatus = () => {
        if (isCompleted) return;
        setClearanceSteps(prev =>
            prev.map(step =>
                step.key === "asset-return"
                    ? { ...step, status: step.status === "COMPLETED" ? "PENDING" : "COMPLETED" }
                    : step
            )
        )
    }

    const onSave = async () => {
        if (!userId) return
        setIsLoading(true)
        try {
            const res = await OffboardingService.updateOffboarding(userId, { offboardingProcess: clearanceSteps, status: "InProgress" })
            if (res?.status) {
                showToastNotification("success", "Asset clearance status updated successfully")
                onNext()
            }
        } catch (err) {
            ThrowError(err)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="space-y-6">
            <div className="p-4 border border-dashed border-slate-200 rounded-2xl bg-slate-50/50 space-y-4">
                <h4 className="font-bold text-slate-800">Clearance Items checklist</h4>
                <div className="flex items-center justify-between p-3.5 bg-white border border-slate-100 rounded-xl hover:shadow-sm transition-shadow">
                    <div>
                        <p className="font-bold text-slate-900">Asset Return</p>
                        <p className="text-xs text-slate-500">Ensure laptop, access cards, mouse and phone are returned.</p>
                    </div>
                    <Button
                        type="button"
                        variant={isAssetCompleted ? "default" : "outline"}
                        disabled={isCompleted}
                        onClick={toggleStatus}
                        className={`rounded-xl transition-all ${isAssetCompleted
                            ? 'bg-green-600 hover:bg-green-700 text-white'
                            : 'text-slate-600 hover:bg-slate-100'
                            }`}
                    >
                        {isAssetCompleted ? 'Returned' : 'Mark Returned'}
                    </Button>
                </div>
            </div>
            <div className="flex justify-end pt-4">
                {!isCompleted ? (
                    <Button
                        type="button"
                        disabled={isLoading}
                        onClick={onSave}
                        className="px-6 rounded-xl"
                    >
                        {isLoading ? <Spinner /> : 'Save and Continue'}
                    </Button>
                ) : (
                    <Button type="button" onClick={onNext} className="px-6 rounded-xl">
                        Next Step
                    </Button>
                )}
            </div>
        </div>
    )
}

export default AssetClearanceStep
